import {
  Box,
  createStyles,
  Text,
  Button,
  TextInput,
  Tooltip,
} from "@mantine/core";
import React, { useEffect, useState } from "react";
import "./style.css";
import PreviousInvoices from "./PreviousInvoices";
import { useSelector } from "react-redux";
import { getAllBillingInvoices } from "../../../services/billinginvoice";
import TableLoader from "../../TableLoader";
import { getInvoicesSetting, getStripAccountForInovices } from "../../../services/invoicesetting";
import { CiSearch } from "react-icons/ci";
import { IoMdAdd } from "react-icons/io";


const bgColor = "#D9D9D9";

const useStyles = createStyles((theme) => ({
  textInputBox: {
    width: "15%",
    padding: "5px 11px",
    borderRadius: "5px",
    backgroundColor: bgColor,
    "& input": {
      border: "none",
      paddingInline: 0,
      backgroundColor: "transparent",
    },
  },
}));

const Dashboard = ({ setState }) => {
  const [selectedMonth, setSelectedMonth] = useState(1);
  const { classes } = useStyles();
  const [loading, setLoading] = useState(false);
  const [paginationState, setPaginationState] = useState(false);

  const { allbillinginvoices } = useSelector(
    (state) => state.billinginvoiceReducer
  );

 const { stripeaccounts  } = useSelector(
    (state) => state.settinginvoice
  );


  // console.log('stripeaccounts',stripeaccounts);

//  console.log('stripeaccounts tets',stripeaccounts.StripeAccounts.stripeAccountdetails.requirements?.currently_due);


const status = stripeaccounts?.StripeAccounts?.stripeAccountStatus;

// console.log('status',status);


  const [searchQuery, setSearchQuery] = useState("");
  const [debounceTimeout, setDebounceTimeout] = useState(null);

    const { profile } = useSelector((state) => state?.profile);

     const {settingInvoice} = useSelector(
        (state) => state.settinginvoice
      );

// console.log('settingInvoice',settingInvoice);

// console.log('profile',profile);




  const handleSearch = (event) => {
    const query = event.target.value;
    setSearchQuery(query); // Update the search query state

    // Clear the previous timeout to reset the debouncing process
    if (debounceTimeout) {
      clearTimeout(debounceTimeout);
    }

    // Set a new timeout to call the API after 500ms delay
    const timeout = setTimeout(() => {
      getAllBillingInvoices({ query, page: 1 }); // Trigger the API call
    }, 500); // 500ms delay

    setDebounceTimeout(timeout); // Store the timeout ID to clear it later
  };

  useEffect(() => {
    // Cleanup the timeout when the component unmounts
    return () => {
      if (debounceTimeout) {
        clearTimeout(debounceTimeout);
      }
    };
  }, [debounceTimeout]);

  const handleMonthChange = (value) => {
    setSelectedMonth(value);
  };

  // console.log('allbillinginvoices',allbillinginvoices);

  let months = [
    { January: 1 },
    { February: 2 },
    { March: 3 },
    { April: 4 },
    { May: 5 },
    { June: 6 },
    { July: 7 },
    { August: 8 },
    { September: 9 },
    { October: 10 },
    { November: 11 },
    { December: 12 },
  ];

  useEffect(() => {
    const fetchInvoices = async () => {
      setLoading(true);
      const payload = {
        page: 1,
        selectedMonth,
      };
      try {
        let res = await getAllBillingInvoices(payload);
        await getInvoicesSetting();
        await getStripAccountForInovices()
        if (res.status === 200) {
          setLoading(false);
        }
      } catch (error) {
        console.error("Error fetching invoices:", error);
        setLoading(false);
      }
    };

    fetchInvoices();
  }, [selectedMonth]);


  // console.log('stripeaccounts',stripeaccounts);
  

  return (
    <>
      <div className="maindashbordinvoices">
        <Text fs={16} fw={700} color="#171717">
          Total Receivables
        </Text>

        {loading ? (
          <TableLoader />
        ) : (
          <Box className="total-receivables-section">
            {/* <Text fs={14} fw={600} color="#737373">
        Month
      </Text> */}

            {/* <Select
        // style={{width:'15%',marginTop:'10px',marginBottom:'10px'}}
        className={classes.textInputBox}
        //  label="Month"
        // placeholder="Pick value"
        value={selectedMonth} 
        onChange={handleMonthChange}
        data={months.map((month) => ({
          value: Object.values(month)[0], 
          label: Object.keys(month)[0], 
        }))}
      /> */}

            <Box className="total-receivables-container">
              <Box className="total-receivables-box">
                <Text fs={12} fw={400} color="#262626">
                  PAID
                </Text>
                <Text className="price" fs={14} fw={600} color="#00A991">
                  ${(allbillinginvoices?.billinginvoicestats?.paid || 0).toLocaleString("en-US")}
                </Text>
              </Box>

              <Box className="total-receivables-box">
                <Text fs={12} fw={400} color="#262626">
                  OVERDUE
                </Text>
                <Text className="price" fs={14} fw={600} color="#F04438">
                  ${(allbillinginvoices?.billinginvoicestats?.overdue || 0).toLocaleString("en-US")}
                </Text>
              </Box>

              <Box className="total-receivables-box">
                <Text fs={12} fw={400} color="#737373">
                  INVOICE SENT{" "}
                </Text>
                <Text className="price" fs={14} fw={600} color="#262626">
                  {allbillinginvoices?.billinginvoicestats?.totalinvoices || 0}
                </Text>
              </Box>

              <Box className="total-receivables-box">
                <Text fs={12} fw={400} color="#737373">
                  TOTAL
                </Text>
                <Text className="price" fs={14} fw={600} color="#262626">
                  {/* ${allbillinginvoices?.billinginvoicestats?.totalreceived || 0} */}
                  ${(allbillinginvoices?.billinginvoicestats?.totalreceived || 0).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                </Text>
              </Box>
            </Box>
          </Box>
        )}

        <Box className="allInvoicesSection">
          <Text fs={16} fw={700} color="#171717">
            All Invoices
          </Text>

          <Box style={{display:'flex',gap:'5px'}}>

          {/* {
                (!stripeaccounts?.StripeAccounts || stripeaccounts?.StripeAccounts?.stripeAccountStatus === 'pending') && 
                (settingInvoice?.settinginvoice?.paymentsOptions?.debitCredit ||
                 settingInvoice?.settinginvoice?.paymentsOptions?.ach)
              
                      ? 
          
          <Tooltip
          label="Your stripe account is not registered, go to settings tab and update it."
          withArrow
          position="bottom"
        >
          <img
            width={20}
            height={20}
             style={{ position: "relative", top: "13px" }}
            src="/assets/images/error.png"
            alt="check-icon"
          />
        </Tooltip>
          
          : null} */}

{
  (
    !stripeaccounts?.StripeAccounts || (
      stripeaccounts?.StripeAccounts?.stripeAccountStatus === 'pending' &&
      (
        settingInvoice?.settinginvoice?.paymentsOptions?.debitCredit ||
        settingInvoice?.settinginvoice?.paymentsOptions?.ach
      )
    )
  ) ? (
    <Tooltip
      label="Your stripe account is not registered, go to settings tab and update it."
      withArrow
      position="bottom"
    >
      <img
        width={20}
        height={20}
        style={{ position: "relative", top: "13px" }}
        src="/assets/images/error.png"
        alt="check-icon"
      />
    </Tooltip>
  ) : null
}




          <Button
            // onClick={nextbtn}
            // className={classes.flexend}
            // onClick={nextbtn}
            onClick={() => {
              setState(true);
            }}
            variant="filled"
            type="submit"
            // disabled={
            //   // (stripeaccounts?.StripeAccounts?.stripeAccountStatus === 'pending' && (settingInvoice?.settinginvoice?.paymentsOptions?.debitCredit ||
            //   // settingInvoice?.settinginvoice?.paymentsOptions?.ach) )
            //   (!stripeaccounts?.StripeAccounts  ||stripeaccounts?.StripeAccounts?.stripeAccountStatus === 'pending') && 
            //   (settingInvoice?.settinginvoice?.paymentsOptions?.debitCredit ||
            //    settingInvoice?.settinginvoice?.paymentsOptions?.ach)
            // }

            disabled={
              !stripeaccounts?.StripeAccounts || (
                stripeaccounts?.StripeAccounts?.stripeAccountStatus === 'pending' &&
                (
                  settingInvoice?.settinginvoice?.paymentsOptions?.debitCredit ||
                  settingInvoice?.settinginvoice?.paymentsOptions?.ach
                )
              )
            }
            
            

 
            c={"#000"}
            radius={"md"}
            size="md"
            color="yellow"
          >


            <IoMdAdd size={25} />
            New Invoice
          </Button>
          </Box>
        </Box>
        <Box className="dashbordinvoices ">
          <TextInput
            rightSection={<CiSearch size={20} color="#737373" />}
            className="search-section"
            value={searchQuery}
      onChange={handleSearch}
            // left={<CiSearch />}
            placeholder="Search invoice #, Customer name, Date"
          />
          <PreviousInvoices setPaginationState={setPaginationState} />
        </Box>
      </div>
    </>
  );
};

export default Dashboard;
